import type { ReactNode } from 'react';

import './EmptyState.scss';

export interface IEmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  children?: ReactNode;
  className?: string;
}

const EmptyState = ({ icon, title, description, children, className }: IEmptyStateProps) => {
  const rootClass = ['empty-state', className].filter(Boolean).join(' ');

  return (
    <div className={rootClass}>
      {icon && <div className="empty-state__icon-chip">{icon}</div>}
      <p className="empty-state__title">{title}</p>
      {description && <p className="empty-state__description">{description}</p>}
      {children}
    </div>
  );
};

export default EmptyState;
